module.exports = __webpack_public_path__ + "static/media/dialogue_box2.2c9027d5.png";